<!-- 关于我们 -->
<template>
    <div class="content">
        <Form :model="storePrams" label-position="right" :label-width="100">
            <FormItem label="官网链接：">
                <Input
                    class="w300"
                    v-model="storePrams.link"
                    type="text"
                    placeholder="请输入官网链接"
                ></Input>
            </FormItem>
            <FormItem label="用户协议：">
                <!-- <Input
                    class="w500"
                    v-model="storePrams.user_agreement"
                    type="textarea"
                    placeholder="请输入用户协议"
                ></Input> -->
                <editor
                    class="w500"
                    :edtor-con="storePrams.user_agreement"
                    :index="1"
                    @getContent="getEnContent1"
                    @getContentchange="getEnContentchange1"
                />
            </FormItem>
            <FormItem label="隐私协议：">
                <!-- <Input
                    class="w500"
                    v-model="storePrams.privacy_policy"
                    type="textarea"
                    placeholder="请输入隐私协议"
                ></Input> -->
                <editor
                    class="w500"
                    :edtor-con="storePrams.privacy_policy"
                    :index="1"
                    @getContent="getEnContent2"
                    @getContentchange="getEnContentchange2"
                />
            </FormItem>
        </Form>
        <div class="footer-btn">
            <Button class="theme-bc" type="warning" @click="goSubmit"
                >保存</Button
            >
        </div>
    </div>
</template>

<script>
import { other_about, other_about_save } from "@/api/index";
import editor from "@/components/editor/editor.vue";
export default {
    components: { editor },
    data() {
        return {
            storePrams: {
                link: "",
                user_agreement: "",
                privacy_policy: "",
            },
        };
    },
    mounted() {
        this.getInfo();
    },
    methods: {
        getInfo() {
            other_about().then((res) => {
                this.storePrams.link = res.data.link;
                this.storePrams.user_agreement = res.data.user_agreement;
                this.storePrams.privacy_policy = res.data.privacy_policy;
            });
        },
        goSubmit() {
            other_about_save(this.storePrams)
                .then((res) => {
                    this.getInfo();
                    this.$Message.success(res.msg);
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        //富文本
        getEnContent1(detailData) {
            this.storePrams.user_agreement = detailData.editorData;
        },
        getEnContentchange1(detailData) {
            this.storePrams.user_agreement = detailData.editorData;
        },
        getEnContent2(detailData) {
            this.storePrams.privacy_policy = detailData.editorData;
        },
        getEnContentchange2(detailData) {
            this.storePrams.privacy_policy = detailData.editorData;
        },
    },
};
</script>

<style scoped>
.content {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.footer-btn {
    margin-top: 24px;
    text-align: right;
}
</style>